import { render, staticRenderFns } from "./CompanyAppointment.vue?vue&type=template&id=70085d13&scoped=true&"
import script from "./CompanyAppointment.vue?vue&type=script&lang=js&"
export * from "./CompanyAppointment.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAppointment.vue?vue&type=style&index=0&id=70085d13&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70085d13",
  null
  
)

export default component.exports